import { lazyNamed, lazyWithRetry } from "src/utils/lazy-named";
import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { AssetType } from "src/types/visual";

const campaignsImport = () => import("./campaigns");
const campaignsTableImport = () => import("./campaigns-table");
const Campaigns = lazyWithRetry(campaignsImport);
const CampaignsTable = lazyNamed(campaignsTableImport, "CampaignsTable");

export const preloads: RoutePreload[] = [
  [
    "/campaigns",
    () => Promise.all([campaignsImport(), campaignsTableImport()]),
  ],
];

export const routes: Array<RouteObject> = [
  {
    path: "campaigns",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to={`/campaigns/${AssetType.Email}`} replace />,
  },
  {
    path: "campaigns",
    spacesAccess: "hidden-from-limited-view",
    element: <Campaigns />,
    children: [
      {
        path: ":assetType",
        spacesAccess: "hidden-from-limited-view",
        element: <CampaignsTable />,
        children: [
          {
            path: ":savedViewId",
            spacesAccess: "hidden-from-limited-view",
            element: <></>,
          },
        ],
      },
    ],
  },
  {
    index: true,
    spacesAccess: "hidden-from-limited-view",
    element: (
      <Navigate
        to={{
          pathname: `campaigns/${AssetType.Email}`,
          search: location.search,
        }}
        replace
      />
    ),
  },
];
